import { render, staticRenderFns } from "./SafeDetail.vue?vue&type=template&id=267d229e&scoped=true"
import script from "./SafeDetail.vue?vue&type=script&lang=js"
export * from "./SafeDetail.vue?vue&type=script&lang=js"
import style0 from "./SafeDetail.vue?vue&type=style&index=0&id=267d229e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267d229e",
  null
  
)

export default component.exports